import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {setGetKyc} from '../../store/thunk/setGetKyc';
import TemplatePage from '../../../components/templatePage';
import KycItem from '../../components/kycItem';

const KycList = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetKyc({
            page: 1,
            rowsPerPage: 10,
            search: ''
        }))
    }, [])

    const list = useSelector(state => state.kycMobile.list);

    return (
        <TemplatePage
            title="Верификация пользователей"
            // pagination={page < list.countPage && list.data.length}
            // handleLoadPagination={() => handleLoadPagination({
            //     page,
            //     setPage,
            //     countPage: list.countPage,
            //     dispatch
            // })}
            // handleLoading={() => handleLoading(dispatch)}
        >
            {
                list.data.map((item) => <KycItem item={item}/>)
            }
            {
                !list.data.length && <span style={{width: '100%', color: '#fff', display: 'flex', justifyContent: 'center', padding: 20}}>Информация отсутствует</span>
            }
        </TemplatePage>
    )
}

export default KycList;